import { render } from "./Comment.vue?vue&type=template&id=bac3d034&scoped=true&ts=true"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"

import "./Comment.vue?vue&type=style&index=0&id=bac3d034&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac3d034"],['__file',"src/components/CommentSection/Comment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bac3d034"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bac3d034', __exports__)) {
    console.log('reload')
    api.reload('bac3d034', __exports__)
  }
  
  module.hot.accept("./Comment.vue?vue&type=template&id=bac3d034&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('bac3d034', render)
  })

}


export default __exports__